// src/components/molecules/SurefirePaywallPopup.js

import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
// import { FiX, FiCheck } from 'react-icons/fi';
import { FiX, FiCpu, FiShuffle, FiTarget } from 'react-icons/fi'; // Dodano nowe ikony
import orzelPromoIcon from '../../img/icons/orzel_rece.png'; // Upewnij się, że ścieżka jest poprawna

// --- Warianty animacji (skopiowane z PaywallPopup dla spójności) ---
const backdropVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

const modalVariants = {
  hidden: { opacity: 0, y: 50, scale: 0.9 },
  visible: { opacity: 1, y: 0, scale: 1, transition: { type: 'spring', bounce: 0, duration: 0.4 } },
  exit: { opacity: 0, y: 50, scale: 0.9, transition: { duration: 0.2 } },
};

// Ten sam modal obsługuje oba tory nauki — różni się wyłącznie treścią.
// Niepewniaki to content rozszerzenia, więc nie mogą mówić o pewniakach i podstawie.
const VARIANTS = {
  surefire: {
    heading: 'Pewniak Zablokowany 🔒',
    subheading: 'Pełna lista pewniaków jest dostępna wyłącznie dla użytkowników Premium.',
    cta: 'Odblokuj dostęp',
    benefits: [
      {
        Icon: FiCpu,
        color: '#233855',
        title: 'Selekcja zadań',
        text: 'Prześwietliliśmy arkusze i wybraliśmy schematy, które CKE najczęściej wrzuca na maturę.',
      },
      {
        Icon: FiShuffle,
        color: '#E09F2E',
        title: 'Opanowanie',
        text: 'System nauki, utrwalania i powtórek zabetonuje Ci rozwiązanie w głowie.',
      },
      {
        Icon: FiTarget,
        color: '#007D00',
        title: 'Podstawy',
        text: 'To baza do bardziej skomplikowanych zadań i wyższego wyniku.',
      },
    ],
  },
  niepewniak: {
    heading: 'Niepewniak Zablokowany 🔒',
    subheading: 'Niepewniaki wchodzą w skład dostępu do Matury Rozszerzonej.',
    cta: 'Odblokuj rozszerzenie',
    benefits: [
      {
        Icon: FiCpu,
        color: '#233855',
        title: 'Selekcja zadań',
        text: 'Prześwietliliśmy arkusze rozszerzone i wybraliśmy schematy, które CKE powtarza rok po roku.',
      },
      {
        Icon: FiShuffle,
        color: '#E09F2E',
        title: 'Opanowanie',
        text: 'System nauki, utrwalania i powtórek zabetonuje Ci rozwiązanie w głowie.',
      },
      {
        Icon: FiTarget,
        color: '#007D00',
        title: 'Zadania otwarte',
        text: 'Pełne rozwiązania krok po kroku — tam, gdzie na rozszerzeniu leżą punkty.',
      },
    ],
  },
};

const SurefirePaywallPopup = ({ isOpen, onClose, onSubscribe, variant = 'surefire' }) => {
  if (!isOpen) return null;

  const { heading, subheading, cta, benefits } = VARIANTS[variant] || VARIANTS.surefire;

  return (
    <motion.div
      className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[9999] flex items-center justify-center p-4"
      variants={backdropVariants}
      initial="hidden"
      animate="visible"
      exit="hidden"
      onClick={onClose}
    >
      <motion.div
        className="bg-white rounded-xl lg:rounded-2xl shadow-[0_8px_30px_-5px_rgba(35,56,85,0.15)] w-full max-w-sm mx-auto overflow-hidden relative"
        variants={modalVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Przycisk zamknięcia */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 z-10 transition-colors"
        >
          <FiX size={24} />
        </button>

        <div className="p-6 flex flex-col items-center text-center">
          
          {/* 1. Ikona Orła */}
          <div className="flex justify-center mb-4 mt-2">
            <img 
              src={orzelPromoIcon} 
              alt="Orzeł Ręce" 
              className="h-24 w-24 object-contain" 
            />
          </div>

          {/* 2. Nagłówek */}
          <h2 className="text-2xl font-apotek tracking-wider text-[#233855] mb-2 uppercase font-bold leading-none">
            {heading}
          </h2>

          <p className="text-gray-500 text-sm leading-tight mb-5 px-2">
            {subheading}
          </p>

          {/* 3. Kontener z korzyściami */}
          <div className="w-full bg-white border border-gray-100 rounded-xl p-4 mb-6 text-left space-y-4 shadow-[0_2px_12px_-4px_rgba(35,56,85,0.08)]">
            {benefits.map(({ Icon, color, title, text }) => (
              <div key={title} className="flex items-start text-xs text-gray-600">
                <Icon className="mr-2.5 text-lg mt-0.5 flex-shrink-0" style={{ color }} />
                <span className="leading-snug">
                  <strong
                    className="block mb-0.5 uppercase tracking-wide font-bold"
                    style={{ color }}
                  >
                    {title}
                  </strong>
                  {text}
                </span>
              </div>
            ))}
          </div>

          {/* 4. Przycisk CTA */}
          <button
            onClick={onSubscribe}
            className="w-full py-3 bg-[#E09F2E] hover:bg-[#c98e28] text-white font-apotek text-lg uppercase tracking-widest rounded-lg shadow-lg transition-all transform active:scale-[0.98] mb-3"
          >
            {cta}
          </button>

          {/* 5. Przycisk wtórny */}
          <button 
            onClick={onClose}
            className="text-[10px] text-gray-400 hover:text-gray-600 uppercase tracking-wider font-bold transition-colors"
          >
            Może później
          </button>

        </div>
      </motion.div>
    </motion.div>
  );
};

export default SurefirePaywallPopup;